import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

function InfoModal({ buttonSize = "sm", buttonVariant = "outline-primary", buttonText, modalTitle, modalBodyText, modalConfirmButtonPrimaryText = "OK" }) {
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    return (
        <>
            <Button size={buttonSize} variant={buttonVariant} onClick={handleShow}>
                {buttonText}
            </Button>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{modalTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{modalBodyText}</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={handleClose}>
                        {modalConfirmButtonPrimaryText}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default InfoModal;
